import {
  ImageData,
  PLAN_ENTERPRISE,
  PLAN_FREE,
  PLAN_PRO,
  PLAN_STARTER,
} from '../images';
import { toTitleCase } from '.';
import { AclPermissionsRole } from '@eventmanager/types';

type UserName = {
  firstName: string;
  lastName: string;
};

export function nameFromEmail(email: string): UserName {
  const username = email.substring(0, email.indexOf('@')).split(/\.|_|-/);
  const [firstName, lastName] = username.map(name => toTitleCase(name));

  return { firstName, lastName };
}

const planImageMap = {
  free: PLAN_FREE,
  pro: PLAN_PRO,
  starter: PLAN_STARTER,
  enterprise: PLAN_ENTERPRISE,
  custom: PLAN_ENTERPRISE,
};

export function getPlanImage(role: string): ImageData {
  return planImageMap[role as AclPermissionsRole] || planImageMap.pro;
}
